/* Cartec Essentials — inline header search (producten via predictive API + kennisbank via thema-index) */
(function () {
  function init(root) {
    var form = root.querySelector('[data-ce-search]');
    if (!form || form.dataset.ceBound) return;
    form.dataset.ceBound = '1';

    var input = form.querySelector('[data-ce-search-input]');
    var results = form.querySelector('[data-ce-search-results]');
    var kbIndex = [];
    try {
      var raw = document.querySelector('[data-ce-kb]');
      if (raw) kbIndex = JSON.parse(raw.textContent || '[]');
    } catch (e) { kbIndex = []; }

    var timer = null;
    var lastQ = '';

    function esc(str) {
      return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function hide() { results.hidden = true; results.innerHTML = ''; }

    function searchKb(q) {
      var ql = q.toLowerCase();
      return kbIndex.filter(function (e) {
        return (e.t && e.t.toLowerCase().indexOf(ql) !== -1) ||
               (e.c && e.c.toLowerCase().indexOf(ql) !== -1) ||
               (e.d && e.d.toLowerCase().indexOf(ql) !== -1);
      }).slice(0, 4);
    }

    function render(products, collections, kb, q) {
      var html = '';
      if (products.length) {
        html += '<div class="ce-srch__group"><div class="ce-srch__grouptitle">Producten</div>';
        products.forEach(function (p) {
          var img = p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy">' : '<span class="ce-srch__noimg"></span>';
          html += '<a class="ce-srch__prod" href="' + esc(p.url) + '">' +
            '<span class="ce-srch__thumb">' + img + '</span>' +
            '<span class="ce-srch__pinfo"><span class="ce-srch__pname">' + esc(p.title) + '</span>' +
            (p.price ? '<span class="ce-srch__pprice">' + esc(p.price) + '</span>' : '') + '</span></a>';
        });
        html += '</div>';
      }
      if (collections.length) {
        html += '<div class="ce-srch__group"><div class="ce-srch__grouptitle">Collecties</div>';
        collections.forEach(function (c) {
          html += '<a class="ce-srch__col" href="' + esc(c.url) + '">' +
            '<span class="ce-srch__colname">' + esc(c.title) + '</span></a>';
        });
        html += '</div>';
      }
      if (kb.length) {
        html += '<div class="ce-srch__group"><div class="ce-srch__grouptitle">Kennisbank</div>';
        kb.forEach(function (e) {
          html += '<a class="ce-srch__kb" href="' + esc(e.u) + '">' +
            (e.c ? '<span class="ce-srch__kbcat">' + esc(e.c) + '</span>' : '') +
            '<span class="ce-srch__kbtitle">' + esc(e.t) + '</span></a>';
        });
        html += '</div>';
      }
      if (!html) {
        html = '<div class="ce-srch__empty">Geen resultaten voor “' + esc(q) + '”.</div>';
      }
      html += '<a class="ce-srch__all" href="/search?q=' + encodeURIComponent(q) + '">Bekijk alle resultaten voor “' + esc(q) + '” →</a>';
      results.innerHTML = html;
      results.hidden = false;
    }

    function run(q) {
      var kb = searchKb(q);
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
            '&resources[type]=product,collection&resources[limit]=5&resources[options][unavailable_products]=last')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var res = (data && data.resources && data.resources.results) || {};
          var products = res.products || [];
          var collections = res.collections || [];
          if (q !== lastQ) return;
          render(products, collections, kb, q);
        })
        .catch(function () { if (q === lastQ) render([], [], kb, q); });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      lastQ = q;
      clearTimeout(timer);
      if (q.length < 2) { hide(); return; }
      timer = setTimeout(function () { run(q); }, 220);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2 && results.innerHTML) results.hidden = false;
    });

    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) hide();
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { hide(); input.blur(); }
    });
  }

  if (document.readyState !== 'loading') init(document);
  else document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
